import PropTypes from 'prop-types';
import React from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import DashboardContainer from 'common/dashboard/containers/dashboard-container';
import AlertsAll from 'common/alerts/containers/alert-all-container';

const CustomerDashboard = ({ id, renderMenu }) =>
  <>
    <DashboardContainer
      type='customer'
      id={id}
      hasInstalledAts={true}
      canCreateTicket={true}
      canCreateOrder={false}
      renderMenu={renderMenu}
    />
    <Routes>
      <Route path={'alerts'} element={<AlertsAll />} />
    </Routes>
    <Outlet />
  </>;
CustomerDashboard.propTypes = {
  id: PropTypes.string,
  renderMenu: PropTypes.func.isRequired,
};

export default CustomerDashboard;
